function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(246, 243, 234)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'grey-london': 'rgb(132, 126, 112)','peach-rio': 'rgb(200, 130, 103)','pink-rio': 'rgb(205, 135, 139)','olive': 'rgb(90, 93, 63)','beige': 'rgb(198, 178, 149)','ube': 'rgb(192, 124, 146)','dragonfruit': 'rgb(200, 76, 97)','mango': 'rgb(176, 96, 83)','guava': 'rgb(172, 100, 97)','coconut': 'rgb(216, 212, 197)','malibu': 'rgb(139, 83, 55)','waikiki': 'rgb(124, 72, 45)','bora-bora': 'rgb(108, 64, 42)','aurora': 'rgb(143, 98, 76)','ethereal': 'rgb(194, 122, 67)','courage': 'rgb(149, 40, 54)','harmony': 'rgb(201, 101, 108)','influence': 'rgb(212, 40, 91)','wisdom': 'rgb(225, 66, 81)',};

    this.images = {'amber': 'url("//humaneathome.com/cdn/shop/files/athr-beauty-amber-swatch_120x.png?v=16835229201842713547")','ruby': 'url("//humaneathome.com/cdn/shop/files/athr-beauty-ruby-swatch_120x.png?v=9542723821176193003")',};

    this.triggers = ['color','shade',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
